<ng-container *ngFor="let item of items">
  <li class="card py-lg-4 px-3 my-3">
    <p> <strong> {{item?.sessionName}} </strong></p>
    <ul class="m-0">
      <li>{{'calendar.start_date' | translate}} : {{item?.startDate | date:"MM.dd.yyyy HH:mm"  }} </li>
      <li>{{'calendar.end_date' | translate}} : {{item?.endDate | date:"MM.dd.yyyy HH:mm" }} </li>
      <li *ngIf="false == item?.is_online"> {{'calendar.address' | translate}} : {{item?.address}}</li>
      <li> {{'calendar.effective' | translate}} {{item?.disponiblePlaces}}</li>
    </ul>
  </li>
</ng-container>
